import Parse from 'html-react-parser';

function BMP20202(props) {
    let svgCode =
    `<svg width="64" height="240" viewBox="0 0 64 240" fill="none" xmlns="http://www.w3.org/2000/svg">
    <style type="text/css">
    ${props.fontFace}
    </style>
        <rect width="64" height="58" rx="4" fill="${props.backgroundFill}"/>
        <path d="M47.9298 27.9298L34.2391 27.9194L47.9194 14.2391L47.9298 27.9298Z" fill="white"/>
        <path d="M18 22.5C28.0205 12.1697 33.6029 11.6123 43.5073 18.8117L38.5059 23.6753C33.1528 17.4449 28.7033 17.1 18 22.5Z" fill="white"/>
        <path d="M17 30L30.6907 30.0104L17.0104 43.6907L17 30Z" fill="white"/>
        <path d="M46.9298 35.4298C36.9093 45.76 31.3269 46.3175 21.4225 39.1181L26.4238 34.2545C31.777 40.4848 36.2265 40.8297 46.9298 35.4298Z" fill="white"/>
        <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="18" font-weight="500" letter-spacing="-0.02em"><tspan x="0" y="87.1523">REPEAT&#10;</tspan><tspan x="0" y="107.152">ACTION</tspan></text>
        <rect y="120" width="64" height="58" rx="4" fill="${props.backgroundFill}"/>
        <path d="M47.9298 147.93L34.2391 147.919L47.9194 134.239L47.9298 147.93Z" fill="${props.highlightColour}"/>
        <path d="M18 142.5C28.0205 132.17 33.6029 131.612 43.5073 138.812L38.5059 143.675C33.1528 137.445 28.7033 137.1 18 142.5Z" fill="${props.highlightColour}"/>
        <path d="M17 150L30.6907 150.01L17.0104 163.691L17 150Z" fill="${props.highlightColour}"/>
        <path d="M46.9298 155.43C36.9093 165.76 31.3269 166.317 21.4225 159.118L26.4238 154.254C31.777 160.485 36.2265 160.83 46.9298 155.43Z" fill="${props.highlightColour}"/>
        <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="18" font-weight="500" letter-spacing="-0.02em"><tspan x="0" y="207.152">REPEAT&#10;</tspan><tspan x="0" y="227.152">ACTION</tspan></text>
    </svg>`

    props.svgReturn(75, svgCode, "bmp00202", 64, 240);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20202;